module.exports = __webpack_public_path__ + "img/18_34.47bd6e62.png";